// config/endpoints.ts
export const ENDPOINTS = {
  // ✅ Autenticação
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    REFRESH: '/auth/refresh',
  },

  // ✅ Usuários
  USUARIOS: {
    LIST: '/usuarios',
    CREATE: '/usuarios',
    SEARCH: '/usuarios/search',
    BY_EMAIL: '/usuarios/email',
    BY_ID: (id: string | number) => `/usuarios/${id}`,
    UPDATE: (id: string | number) => `/usuarios/${id}`,
    UPDATE_PASSWORD: (id: string | number) => `/usuarios/${id}/password`,
    DELETE: (id: string | number) => `/usuarios/${id}`,
  },

  // ✅ Empresas
  EMPRESAS: {
    LIST: '/empresas',
    CREATE: '/empresas',
    SEARCH: '/empresas/search',
  BY_ID: (id: string | number) => `/empresas/${id}`,
    UPDATE: (id: string | number) => `/empresas/${id}`,
    DELETE: (id: string | number) => `/empresas/${id}`,
  // Buscar empresas por grupo
  BY_GRUPO: (grupoId: string | number) => `/empresas/grupo/${grupoId}`,
  },

  // ✅ Grupos
  GRUPOS: {
    LIST: '/grupos',
    CREATE: '/grupos',
    SEARCH: '/grupos/search',
    BY_ID: (id: string | number) => `/grupos/${id}`,
    UPDATE: (id: string | number) => `/grupos/${id}`,
    DELETE: (id: string | number) => `/grupos/${id}`,
  },

  // ✅ Clientes
  CLIENTES: {
    LIST: '/clientes',
    CREATE: '/clientes',
    SEARCH: '/clientes/search',
    BY_ID: (id: string | number) => `/clientes/${id}`,
    UPDATE: (id: string | number) => `/clientes/${id}`,
    DELETE: (id: string | number) => `/clientes/${id}`,
  },

  // ✅ Catálogos
  CATALOGS: {
    // Seguradoras
    SEGURADORAS: {
      LIST: '/catalogs/seguradoras',
      CREATE: '/catalogs/seguradoras',
      SEARCH: '/catalogs/seguradoras/search',
      BY_ID: (id: string | number) => `/catalogs/seguradoras/${id}`,
      UPDATE: (id: string | number) => `/catalogs/seguradoras/${id}`,
      DELETE: (id: string | number) => `/catalogs/seguradoras/${id}`,
    },
    
    // Produtos
    PRODUTOS: {
      LIST: '/catalogs/produtos',
      CREATE: '/catalogs/produtos',
      SEARCH: '/catalogs/produtos/search',
      BY_ID: (id: string | number) => `/catalogs/produtos/${id}`,
      UPDATE: (id: string | number) => `/catalogs/produtos/${id}`,
      DELETE: (id: string | number) => `/catalogs/produtos/${id}`,
    },
    
    // Formas de Pagamento
    PAGAMENTOS: {
      LIST: '/catalogs/pagamentos',
      CREATE: '/catalogs/pagamentos',
      SEARCH: '/catalogs/pagamentos/search',
      BY_ID: (id: string | number) => `/catalogs/pagamentos/${id}`,
      UPDATE: (id: string | number) => `/catalogs/pagamentos/${id}`,
      DELETE: (id: string | number) => `/catalogs/pagamentos/${id}`,
    },
    
    // Status
    STATUS: {
      LIST: '/catalogs/status',
      CREATE: '/catalogs/status',
      SEARCH: '/catalogs/status/search',
      BY_ID: (id: string | number) => `/catalogs/status/${id}`,
      UPDATE: (id: string | number) => `/catalogs/status/${id}`,
      DELETE: (id: string | number) => `/catalogs/status/${id}`,
    },
    
    // Situações
    SITUACOES: {
      LIST: '/catalogs/situacoes',
      CREATE: '/catalogs/situacoes',
      SEARCH: '/catalogs/situacoes/search',
      BY_ID: (id: string | number) => `/catalogs/situacoes/${id}`,
      UPDATE: (id: string | number) => `/catalogs/situacoes/${id}`,
      DELETE: (id: string | number) => `/catalogs/situacoes/${id}`,
    },
    // Sinistros (catálogo)
    SINISTROS: {
      LIST: '/catalogs/sinistros',
      CREATE: '/catalogs/sinistros',
      SEARCH: '/catalogs/sinistros/search',
      BY_ID: (id: string | number) => `/catalogs/sinistros/${id}`,
      UPDATE: (id: string | number) => `/catalogs/sinistros/${id}`,
      DELETE: (id: string | number) => `/catalogs/sinistros/${id}`,
    },
  },

  // ✅ Documentos/Propostas
  DOCUMENTOS: {
    LIST: '/documentos',
    CREATE: '/documentos',
    SEARCH: '/documentos/search',
    BY_ID: (id: string | number) => `/documentos/${id}?include=parcelas,repasses,sinistros`,
    UPDATE: (id: string | number) => `/documentos/${id}`,
    DELETE: (id: string | number) => `/documentos/${id}`,
    RENOVACOES: '/documentos/renovacoes',
    PROPOSTAS: '/documentos/propostas',
  },

  // ✅ Parcelas
  PARCELAS: {
    LIST: '/parcelas',
    CREATE: '/parcelas',
    SEARCH: '/parcelas/search',
    BY_ID: (id: string | number) => `/parcelas/${id}`,
    UPDATE: (id: string | number) => `/parcelas/${id}`,
    DELETE: (id: string | number) => `/parcelas/${id}`,
  },

  // ✅ Agendamentos
  AGENDAMENTOS: {
    LIST: '/agendamentos',
    CREATE: '/agendamentos',
    SEARCH: '/agendamentos/search',
    BY_ID: (id: string | number) => `/agendamentos/${id}`,
    UPDATE: (id: string | number) => `/agendamentos/${id}`,
    DELETE: (id: string | number) => `/agendamentos/${id}`,
  },

  // ✅ Importação
  IMPORTACAO: {
    CLIENTE: '/importacao/cliente',           // RptClienteLista.XLS
    ANALISE: '/importacao/analise',           // RptAnaliseProducao.XLS
    MULTCALCULO: '/importacao/multcalculo',   // RptMultCalculo.XLSX
    PROPOSTAS: '/importacao/propostas',       // RptPropostaPend.XLS
    ACCESS: {
      UPLOAD_IMPORT: '/importacao/access/upload-import',  // Upload + importação em uma chamada (CSV)
      VALIDATE: '/importacao/access/validate',            // Validação de diretório CSV
      TABLES: '/importacao/access/tables',                // Lista tabelas disponíveis
      DATA: '/importacao/access/data',                    // Preview de dados
      IMPORT: '/importacao/access/import',                // Importação (arquivos já no servidor)
      QUERY: '/importacao/access/query',                  // Query avançada (debug)
    },
  },

  // ✅ Cálculo de Comissão
  CALCULO: {
    LIST: '/calculo',
    CREATE: '/calculo',
    SEARCH: '/calculo/search',
    COMISSAO: '/calculo/comissao',
    BY_ID: (id: string | number) => `/calculo/${id}`,
    UPDATE: (id: string | number) => `/calculo/${id}`,
    DELETE: (id: string | number) => `/calculo/${id}`,
  },

  // ✅ Health Check
  HEALTH: '/health',

  // ✅ Digisac (WhatsApp)
  DIGISAC: {
    MESSAGES: '/digisac/messages',
    SEND_TEMPLATE: '/digisac/messages/template',
    SYNC_STATUS: (id: string) => `/digisac/messages/${id}/sync-status`,
    SCHEDULES: '/digisac/schedules',
    CANCEL_SCHEDULE: (id: string) => `/digisac/schedules/${id}`,
  },
} as const;

// ✅ Tipos para paginação e busca
export interface PaginationParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface SearchParams {
  search?: string;
}

export type QueryParams = PaginationParams & SearchParams;

// ✅ Helper para construir query string
export const buildQueryString = (params: QueryParams): string => {
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

// ✅ Tipos de response padrão da API
export interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  success: boolean;
  message?: string;
}